import { useCallback } from 'react';
import SettingsForm from '../../../components/SettingsForm';
import { getStoreEmailSettings, saveStoreEmailSettings, uploadFile } from '../../../utils/queries';
import { useCan } from '../../../hooks/useCan';
import { PLATFORMADMIN_ROLES } from '../../../components/navConfig';

export default function BrandingEmailTab({ storeId }) {
	const canEdit = useCan(PLATFORMADMIN_ROLES);
	const load = useCallback(() => getStoreEmailSettings(storeId), [storeId]);
	const save = useCallback((fields) => saveStoreEmailSettings(storeId, fields), [storeId]);
	const uploadLogo = useCallback((file) => uploadFile({ file, storeId, kind: 'logo' }), [storeId]);
	const uploadFavicon = useCallback((file) => uploadFile({ file, storeId, kind: 'favicon' }), [storeId]);

	const fields = [
		{ key: 'logoUrl', label: 'Logo', type: 'file', accept: 'image/*', upload: uploadLogo },
		{
			key: 'faviconUrl',
			label: 'Favicon',
			type: 'file',
			accept: 'image/*,.ico',
			upload: uploadFavicon,
		},
		{ key: 'supportEmail', label: 'Support Email' },
		{ key: 'supportPhone', label: 'Support Phone' },
	];

	return (
		<SettingsForm
			load={load}
			save={save}
			fields={fields}
			emptyMessage='No branding settings yet.'
			canEdit={canEdit}
		/>
	);
}
